import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidemenu from '../base/sidemenu';
import { useNavigate } from "react-router-dom";
export default function Department() {
  const [departments, setDepartments] = useState([]);
  const [newDept, setNewDept] = useState('');
  const [editDeptId, setEditDeptId] = useState(null);
  const [editDeptName, setEditDeptName] = useState('');

  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // 목록 불러오기
  const fetchDepartments = async () => {
   
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/department`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setDepartments(res.data.department || res.data);
  };

  useEffect(() => { fetchDepartments(); }, []);

  // 추가
  const handleAdd = async () => {
  if (!newDept.trim()) return alert("소속명을 입력해주세요.");
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/department`, { name: newDept }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.data.success === false) {
      alert(response.data.message);
      return;
    }
    alert(response.data.message);
    setNewDept('');
    fetchDepartments();
  } catch (error) {
    console.error(error);
    alert("추가 중 오류가 발생했습니다.");
  }
};
  // 수정
  const handleEdit = async (id) => {
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/department`, {
        id,
        name: editDeptName
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);
      setEditDeptId(null);
      setEditDeptName('');
      fetchDepartments();
    } catch (error) {
      console.error(error);
      alert("수정 중 오류가 발생했습니다.");
    }
  };
  
  

  // 삭제
  const handleDelete = async (id) => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/department/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);  
      fetchDepartments();
    } catch (error) {
      console.error(error);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };
  

  return (
    <div className="flex">
      <Sidemenu />
      <div className="admin">
        <h1>관리자 관리</h1>
        <div className="admin_box depart_wrp">
          <h2 className="subpage_title">
            <span className="before"><span className="nametit">소속 관리</span></span>
          </h2>          
          <div className='dept_addbtn'>
            <input type="text" value={newDept} onChange={e => setNewDept(e.target.value)} placeholder="새 소속 입력" />
            <button onClick={handleAdd} className='addbtn'>추가</button>
          </div>
          <div className='table'>
            <table>
              <colgroup>
                <col width="10%" />
                <col width="50%" />
                <col width="20%" />
                <col width="20%" />              
              </colgroup>
              <thead>
                <tr>
                  <th scope='col'>번호</th>
                  <th scope='col'>소속명</th>
                  <th scope='col'>수정</th>
                  <th scope='col'>삭제</th>
                </tr>
              </thead>
              <tbody>
                {departments.map((dept, index) => (
                  <tr key={dept.id}>
                    <td>{index + 1}</td>
                    <td>
                      {editDeptId === dept.id ? (
                        <input value={editDeptName} onChange={e => setEditDeptName(e.target.value)} />) : (dept.name)}
                    </td>
                    <td>
                      {editDeptId === dept.id ? (<><button onClick={() => handleEdit(dept.id)} className='svbtn'>저장</button><button onClick={() => { setEditDeptId(null); setEditDeptName(''); }} className='canbtn'>취소</button></>) : (<button onClick={() => {setEditDeptId(dept.id); setEditDeptName(dept.name);}} className='svbtn'>수정</button>)}
                    </td>
                    <td>
                      <button onClick={() => handleDelete(dept.id)} className='delbtn'>삭제</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>  
          <div className="btn-group">
            <button onClick={() => navigate("/admin")} className="btncolor01">확인</button>
          </div>        
        </div>
      </div>
    </div>
  );
}
